module.exports = __webpack_public_path__ + "img/shutterstock-166045121-labeled.7e3fdefb.jpg";